// extracted by mini-css-extract-plugin
module.exports = {"cardsGrid":"project-grid_cardsGrid__KalyO","contentWrapper":"project-grid_contentWrapper__13QuK","headerWrapper":"project-grid_headerWrapper__kpiFx"};